import { useRef } from 'react'
import Styles from './RetryButton.module.scss'
import { useButton } from '@react-aria/button'
import { ArrowRotateLeft2 } from 'blaze-ui/icons'

const RetryButton = ({ onPress }: { onPress?: () => void }) => {
  const ref = useRef<HTMLButtonElement>(null)
  const { buttonProps } = useButton({ onPress }, ref)

  return (
    <button {...buttonProps} ref={ref} className={Styles.root}>
      <ArrowRotateLeft2 size={16} color="var(--light-100)" />
    </button>
  )
}

export default RetryButton
